/* globals CONFIG */

/**
 *
 * @type {{
 *     apiUrl: string;
 *     bigCompanyThreshold: number;
 *     defaultMaxEmployeeCount: number;
 *     periodStartDate: number;
 *     logLevel: string;
 * }}
 */
module.exports = CONFIG;



// WEBPACK FOOTER //
// ./app/config/index.js